import { render, staticRenderFns } from "./bannerDetail.vue?vue&type=template&id=383607d6&scoped=true&"
import script from "./bannerDetail.vue?vue&type=script&lang=js&"
export * from "./bannerDetail.vue?vue&type=script&lang=js&"
import style0 from "./bannerDetail.vue?vue&type=style&index=0&id=383607d6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383607d6",
  null
  
)

export default component.exports